class AjaxResponseActionHandler {
    static $flashMessageContainer = null;

    static ajaxCallback(data) {
        let handler = new AjaxResponseActionHandler(data);
        handler.handleActions();
    }

    constructor(response) {
        if ('data' in response && 'actions' in response) {
            this.data = response.data;
            this.actions = response.actions;
        } else {
            this.data = response;
            this.actions = [];
        }
    }

    getData() {
        return this.data;
    }

    handleActions() {
        for (let i = 0; i < this.actions.length; i++) {
            let action = this.actions[i];
            if (typeof this[action.type + 'Action'] === "function") {
                if (this[action.type + 'Action'](action) === false) {
                    break;
                }
            }
        }
    }

    redirectAction(attributes) {
        if (typeof attributes.sleep !== 'undefined') {
            setTimeout(function() {
                window.location.href = attributes.uri;
            }, attributes.sleep)
        } else {
            window.location.href = attributes.uri;
        }
        return false;
    }

    flashMessageAction(attributes) {
        if (AjaxResponseActionHandler.$flashMessageContainer === null) {
            AjaxResponseActionHandler.$flashMessageContainer = $('<div class="toast-wrapper" style="position: fixed; top: 70px; right: 25px;"></div>');
            AjaxResponseActionHandler.$flashMessageContainer.appendTo('body');
        }
        let $flashMessage = $(AjaxResponseActionHandler.getFlashMessageHtml(attributes));
        $flashMessage.appendTo(AjaxResponseActionHandler.$flashMessageContainer);
        $flashMessage.toast({
            autohide: false
        }).toast('show');
    }

    static getFlashMessageHtml(attributes) {
        let colors = AjaxResponseActionHandler.getFlashMessageColorClasses(attributes.severity);
        return '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast">' +
        '  <div class="toast-header ' + colors.background + ' ' + colors.text + '">' +
        '    <strong class="mr-auto">' + attributes.title + '</strong>' +
        // '    <small>11 mins ago</small>' +
        '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
        '      <span aria-hidden="true">&times;</span>' +
        '    </button>' +
        '  </div>' +
        '  <div class="toast-body">' +
        attributes.message +
        '  </div>' +
        '</div>';
    }

    static getFlashMessageColorClasses(severity) {
        switch (severity) {
            case -2:
                // notice
                return {background: 'bg-secondary', text: 'text-white'};
            case -1:
                //info
                return {background: 'bg-info', text: 'text-white'};
            case 1:
                // warning
                return {background: 'bg-warning', text: 'text-dark'};
            case 2:
                // error
                return {background: 'bg-danger', text: 'text-white'};
            case 0:
            default:
                // ok
                return {background: 'bg-success', text: 'text-white'};

        }
    }
}

export default AjaxResponseActionHandler;